import React from "react";
import { Box, Typography, Switch } from "@mui/material";

const SettingItem = ({ title, description, checked, onToggle, disabled }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
      sx={{
        borderRadius: 3,
        transition: "background 0.2s ease",
        "&:hover": { backgroundColor: "rgba(255,255,255,0.06)" },
      }}
    >
      <Box>
        <Typography variant="subtitle1" sx={{ color: "#fff", fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "#cfcfcf" }}>
          {description}
        </Typography>
      </Box>
      <Switch
        color="secondary"
        checked={checked}
        onChange={(e) => onToggle(e.target.checked)}
        disabled={disabled}
        sx={{
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: "#8266ff",
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#8266ff",
          },
        }}
      />
    </Box>
  );
};

export default SettingItem;
